import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, Ref } from 'vue';
import { DataInstance, InviteLinks, Userspaces } from '@busy-human/opt-library';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '@/util/firebase';
import handleCalendarEvents from '../calendarEvents2'
import loader from "../components/loader.vue"
import { ISOTimestamp } from '@busy-human/gearbox'
import moment from "moment";
import { DayWithMomentChunk, MeetingInfo, ISOTimeChunk, MomentTimeChunk } from './meeting-request-2/meeting-request-types';
import { useMeetingRequestSchedule } from './meeting-request-2/schedule-mixin';

// -- Props and Emit declarations and types

type Props = {
    modelValue?: Date
    popup?: boolean // If set, the calendar will require a submit button be pressed 
    events: ISOTimeChunk[]// TODO: change this type when we get calendar intergrated events
    invite?: DataInstance<InviteLinks.Model>
    setMonth?: number
    setYear?: number
}
type Emits = {
    (e: "update:modelValue", value: Date): void,
    (e: "update:TimesAvailable", value: Object): void,
    (e: "update:BufferedStart", value: Object): void,
    (e: "update:BufferedEnd", value: Object): void,
    (e: "update:MeetingLength", value: Object): void,
    (e: "update:events", value: Number): void,
    (e: "update:setMonth",value: Number): void,
    (e: "update:setYear",value: Number): void,
    (e: "update:blockedDays", value: Object): void,
    (e: "update:disabledDays", value: Object): void,
    (e: "update:selectedDate", value: Object): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'calendar2',
  props: {
    modelValue: null,
    popup: { type: Boolean },
    events: null,
    invite: null,
    setMonth: null,
    setYear: null
  },
  emits: ["update:modelValue", "update:TimesAvailable", "update:BufferedStart", "update:BufferedEnd", "update:MeetingLength", "update:events", "update:setMonth", "update:setYear", "update:blockedDays", "update:disabledDays", "update:selectedDate"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "update:modelValue", value: Date): void,
    (e: "update:TimesAvailable", value: Object): void,
    (e: "update:BufferedStart", value: Object): void,
    (e: "update:BufferedEnd", value: Object): void,
    (e: "update:MeetingLength", value: Object): void,
    (e: "update:events", value: Number): void,
    (e: "update:setMonth",value: Number): void,
    (e: "update:setYear",value: Number): void,
    (e: "update:blockedDays", value: Object): void,
    (e: "update:disabledDays", value: Object): void,
    (e: "update:selectedDate", value: Object): void,
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    modelValue?: Date
    popup?: boolean // If set, the calendar will require a submit button be pressed 
    events: ISOTimeChunk[]// TODO: change this type when we get calendar intergrated events
    invite?: DataInstance<InviteLinks.Model>
    setMonth?: number
    setYear?: number
}



// -- Constants
const now = new Date();
const Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
const Days = ["SUN","MON","TUE","WED","THU","FRI","SAT"]
const daysOfWeek = ["sunday","monday","tuesday","wednesday","thursday","friday","saturday",]
// -- Variables
const currentDate = ref(props.modelValue || now)
const internalValue = ref();
const year = ref(props.modelValue?.getFullYear() || now.getFullYear());
const month = ref(props.modelValue?.getMonth() || now.getMonth());
const disabledDates = ref([])
const disabledDays : Ref<DayWithMomentChunk[]> = ref([])
const blockedOutDays : Ref<DayWithMomentChunk[]> = ref([])
const convertedBlockedDays = ref([])
const timeChunks : Ref<ISOTimeChunk[]> = ref([])
const timesAvailable : Ref<ISOTimeChunk[]> = ref([])
const startOfAvailability = ref()
const endOfAvailability = ref() 
const loading = ref(true)
const meetingLength = ref();

const {updateUserAvailability, events, senderUid} = useMeetingRequestSchedule(null);

if(!props.invite) {
    throw new Error(`Invite is not defined`);
}

const getUserAvailability = httpsCallable<{uid: string, year: number, month: number}, {startTime: string, endTime: string}[]>(functions, 'getUserAvailability') 
const meetingInfo: MeetingInfo  = {
    id: props.invite.collector || props.invite.payer,
    meetingLength: props.invite?.minutes,
    year: year.value,
    month: month.value
}

//onMounted
onMounted (async()=>{
    if(props.setMonth && props.setYear){
        getEvents()
    }else{
        let disabled = new handleCalendarEvents(meetingInfo, events.value)
        // console.log("CALENDAR",meetingInfo)
        await disabled.setData()
        timeChunks.value = disabled.getTimeChunks()
        disabledDays.value = disabled.returnUnavailableDays()
        blockedOutDays.value = disabled.returnBusyDays()
        startOfAvailability.value = moment(disabled.returnBufferedStart())
        endOfAvailability.value = moment(disabled.returnBufferedEnd())
        meetingLength.value = disabled.returnMeetingLength()
        // let today = moment().format("YYYY M DD")
        // let todaySplit = today.split(" ")
        // console.log(todaySplit)
        // setDate(todaySplit[0],todaySplit[1] - 1 ,todaySplit[2])
        // for(let i = 0; i < timeChunks.value.length; i++){
        //     console.log("TIME CHUNKS ON CALENDAR",timeChunks.value[i].start.format("h:mma"),timeChunks.value[i].end.format("h:mma"))
        // }
        // console.log("START:",startOfAvailability.value.format("h:mma"))
        // console.log("END:",endOfAvailability.value.format("h:mma"))
        emit('update:BufferedStart',startOfAvailability.value)
        emit('update:BufferedEnd',endOfAvailability.value)
        emit('update:disabledDays', disabledDays.value)
    }
    emit('update:MeetingLength',meetingLength.value)
})

watch(()=> timeChunks.value, val =>{
    if(val){
        getTimesAvailable()
        getBlockedDays()
        loading.value = false
    }
})


// -- External watcher
watch(() => props.modelValue, val => {
    if(val) {
        year.value = val.getFullYear();
        month.value = val.getMonth();
        internalValue.value = val;
    } else {
        year.value = now.getFullYear();
        month.value = now.getMonth();
        internalValue.value = now;
    }
})

// watch(()=> props.events, events =>{
//     if(events){
//     }
// },{immediate: true, deep:true})

// -- State changing functions 
/**
 * Changes the calendar's view of the time by year
 * @param val Increment the year by this amount
 */
const changeYear = (val: number = 1) => {
    year.value += val;
    emit('update:events')
}
/**
 * Changes the calendar's view of the time by month.
 * If this increases the month over december, it will
 * add to the year and cycle around the month
 * @param val Increment the month by this amount
 */
const changeMonth = async (val: number = 1) => {
    let currentMonth = parseInt(moment().format("M"));
    currentMonth -= 1
    let tmp = month.value + val;
    if(tmp >= currentMonth){
        month.value += val;
        if(month.value > 11) {
            year.value += Math.floor(month.value / 12);
            month.value = Math.floor(month.value % 12);
        } else if(month.value < 0) {
            year.value += Math.floor(month.value / 12);
            month.value = 12 - Math.abs(month.value % 12);
        }
        meetingInfo.month = month.value
        meetingInfo.year = year.value
        await getEvents()
    }
        
}

const getEvents = async() =>{
    if(!props.invite) {
        throw new Error("Invite is required");
    }
    let month:number = meetingInfo.month
    let year:number = meetingInfo.year
    let uid:string = ""
    emit('update:setMonth',month)
    emit('update:setYear',year)
    if(props.invite.collector){
        uid = props.invite.collector
    }else{
        uid = props.invite.payer
    }
    senderUid.value = uid;
    await updateUserAvailability(uid);
    let disabled = new handleCalendarEvents(meetingInfo)
    await disabled.setData()
    timeChunks.value = disabled.getTimeChunks()
    disabledDays.value = disabled.returnUnavailableDays()
    blockedOutDays.value = disabled.returnBusyDays()
    startOfAvailability.value = moment(disabled.returnBufferedStart())
    endOfAvailability.value = moment(disabled.returnBufferedEnd())
    meetingLength.value = disabled.returnMeetingLength()
    // console.log("GET EVENTS IN CALENDAR", timeChunks.value,startOfAvailability.value.format("h:mma"),endOfAvailability.value.format("h:mma"))
    emit('update:BufferedStart',startOfAvailability.value)
    emit('update:BufferedEnd',endOfAvailability.value)
    emit('update:MeetingLength',meetingLength.value)
}

/**
 * Sets the internal date, and bubbles up the chosen date if not
 * in popup mode.
 * @param year 
 * @param month 
 * @param day 
 */
const setDate = (year: number, month: number, day: number) => {
    internalValue.value = new Date(year, month, day);
    emit('update:selectedDate',internalValue.value)
    
    // if(!props.popup) emit('update:modelValue', internalValue.value);
    // let today = new Date()


}
// -- Helpers
/**
 * Gets the week of a month the given date is on
 * @param year 
 * @param month 
 * @param day 
 */
const weekOfMonth = (year: number, month: number, day: number) => {
    const firstDay = new Date(year, month, 1).getDay();
    const offset = new Date(year, month, day).getDate() + firstDay - 1;
    return Math.floor(offset / 7);
}
/**
 * Gets the number of days in a month
 * @param year 
 * @param month 
 */
const daysInMonth = (year: number, month: number) => {
    return new Date(year, month + 1, 0).getDate();
}
/**
 * Gets the number of weeks in a month
 * @param year 
 * @param month 
 */
const weeksInMonth = (year: number, month: number) => {
    return weekOfMonth(year, month + 1, 0);
}
/**
 * Returns which day (monday, tuesday, etc..) a specific day is
 * @param year 
 * @param month 
 * @param day 
 */
const dayOfWeek = (year: number, month: number, day: number) => {
    return new Date(year, month, day).getDay();
}


/**IMPORTANT
 * 
 */

const getBlockedDays = ()=>{
    for(let i = 0; i < blockedOutDays.value.length; i++){
        let blockedDay = blockedOutDays.value[i].format("MMMM D, YYYY")
        convertedBlockedDays.value.push(blockedDay)
    }
    let date = moment().format("DD")
    for(let i = 1; i < parseInt(date); i++){
        let tmp = moment()
        tmp.set('date',i)
        if(i < 10){
            let newDate = tmp.format("MMMM D, YYYY")
            convertedBlockedDays.value.push(newDate)
        }else{
            let newDate = tmp.format("MMMM DD, YYYY")
            convertedBlockedDays.value.push(newDate)
        }
    }
    emit("update:blockedDays",convertedBlockedDays.value)
  

}
const getTimesAvailable = ()=>{
    timesAvailable.value = []
    for(let i = 0; i < timeChunks.value.length; i++){
        // let day = moment(timeChunks.value[i].startTime).format("MMMM D, YYYY");

        // let timeAvailable : MomentTimeChunk = {
        //     startTime: timeChunks.value[i].startTime,
        //     endTime: timeChunks.value[i].endTime,
        // }
        timesAvailable.value.push(timeChunks.value[i])
    }
    // for(let i = 0; i < timesAvailable.value.length; i++){
    //     console.log("TIMES:",timesAvailable.value[i].startTime.format("h:mma"),timesAvailable.value[i].endTime.format("h:mma"))
    // }
    emit('update:TimesAvailable', timesAvailable.value)
}



 
/**
 * 
 * @param passed this is day from the DOM
 * checks to see if the day is disabled and add class of disabled to the date if it is.
 */
const checkDate = (passed) =>{
    if(!passed){
        return false
    }
    let monthString = Months[month.value]
    let dayIndex = dayOfWeek(year.value, month.value, passed)
    let day = daysOfWeek[dayIndex]
    let dateToCheck = `${monthString} ${passed}, ${year.value}`
    if(disabledDates.value.includes(dateToCheck)){
        return true;
    }
    if(convertedBlockedDays.value.includes(dateToCheck)){
        return true;
    }
    if(disabledDays.value.includes(day)){
        return true;
    }
    // for( let i = 0; i < timeChunks.value)
    return false
}



const __returned__ = { props, emit, now, Months, Days, daysOfWeek, currentDate, internalValue, year, month, disabledDates, disabledDays, blockedOutDays, convertedBlockedDays, timeChunks, timesAvailable, startOfAvailability, endOfAvailability, loading, meetingLength, updateUserAvailability, events, senderUid, getUserAvailability, meetingInfo, changeYear, changeMonth, getEvents, setDate, weekOfMonth, daysInMonth, weeksInMonth, dayOfWeek, getBlockedDays, getTimesAvailable, checkDate, ref, watch, onMounted, Ref, DataInstance, InviteLinks, Userspaces, httpsCallable, auth, functions, handleCalendarEvents, loader, ISOTimestamp, moment, DayWithMomentChunk, MeetingInfo, ISOTimeChunk, MomentTimeChunk, useMeetingRequestSchedule }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})